const { addProfile } = require("../actions")

export const saveAnonymousUser = () =>  (dispatch) => {
    fetch('https://api.ipify.org/?format=json')
      .then(response => response.json())
      .then(res => {
            fetch(`https://recruitingmonk-v2.azurewebsites.net/anonymous/${res.ip}`,{
                headeres:{'Content-Type':'application/json'},
                method:'GET',
            })
            .then(response => response.json())
            .then(response => {
                dispatch(addProfile({ip:res.ip}));
                console.log(res.ip)
            })
          }).catch(console.log)
}

